

var Data = [
{
  "title": "Frontend Development",
  "paragraph": "Building responsive, visually appealing web interfaces with HTML, CSS, and JavaScript to deliver seamless user experiences.",
  "icon": 'FaPaintBrush',
},
{
  "title": "Responsive Design",
  "paragraph": "Creating websites that adapt smoothly to different screen sizes and devices, ensuring optimal usability and aesthetics.",
  "icon": "FaDesktop"
}, 
{
  "title": "Developing With React",
  "paragraph": "Building dynamic, high-performance web applications using React.js, focusing on reusable components and modern JavaScript features.",
  "icon": "FaChartArea"
},

{
    "title": "UI/UX Design",
    "paragraph": "Designing user interfaces that are intuitive and visually engaging while optimizing the overall user experience.",
    "icon": "FaPencilRuler"
}, 
{
    "title": "Insure Dynamic Components",
    "paragraph": "Implementing flexible, interactive components that enhance functionality and user engagement on websites and apps.",
    "icon": "FaBullhorn"
},
{
    "title": "Figma to React Conversion",
    "paragraph": "Transforming Figma designs into fully functional React components with precision and attention to design details.",
    "icon": "FaBullhorn"
}
]

  export default Data;